(function (angular, ToyotaForms) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('formsBookATestDrive', ['$filter', 'API', 'SitecoreAnalytics', function ($filter, API, SitecoreAnalytics) {
            formsBookATestDriveController.$inject = ['$scope'];
            function formsBookATestDriveController($scope) {
                $scope.init = function () {

                    $scope.fields = {
                        firstname: '',
                        lastname: '',
                        postcode: '',
                        phone: '',
                        email: '',
                        postCodeOrSuburb: '',
                        dealer: {
                            dealerCode: '',
                            branchCode: '',
                            address: '',
                            name: '',
                            postCode: '',
                            suburb: '',
                            state: '',
                            telephone: '',
                            email: ''
                        },
                        dealerSelected: false,
                        agreement: false,
                        buyingTimeline: '',
                        formName: '',
                        campaignCode: ''
                    };

                    $scope.fieldProps = {
                        phoneMaxLength: 10,
                        phonePattern: /^[0-9]{10}$/,
                        emailPattern: ToyotaForms.RegularExpressions.EmailPattern
                    };

                    $scope.form = {
                        submitting: false,
                        completed: false,
                        success: false
                    };

                    $scope.vehicleModelList = [];
                };

                $scope.init();

                $scope.setPreferredDealer = function (dealer) {
                    $scope.fields.dealerSelected = true;
                    $scope.fields.dealer.dealerCode = dealer.dealerCode;
                    $scope.fields.dealer.branchCode = dealer.branchCode;
                    $scope.fields.dealer.name = dealer.name;
                    $scope.fields.dealer.address = dealer.address;
                    $scope.fields.dealer.suburb = dealer.city;
                    $scope.fields.dealer.postCode = dealer.postCode;
                    $scope.fields.dealer.state = dealer.state;
                    $scope.fields.dealer.telephone = dealer.telephone;
                    $scope.fields.dealer.email = dealer.email;
                };

                $scope.getData = function () {
                    var agreement;
                    if ($('#terms-checkbox').length) {
                        agreement = $scope.fields.agreement;
                    }
                    else {
                        agreement = true;
                    }
                    return {
                        FirstName: $scope.fields.firstname,
                        LastName: $scope.fields.lastname,
                        Email: $scope.fields.email,
                        Phone: $scope.fields.phone,
                        CarSelectionOne: $scope.fields.carSelectionOne,
                        CarSelectionTwo: $scope.vehicleModelList.length > 1 ? $scope.fields[$scope.vehicleModelList[1]] : '',
                        CarSelectionThree: $scope.vehicleModelList.length > 2 ? $scope.fields[$scope.vehicleModelList[2]] : '',
                        Dealer: {
                            Id: $scope.fields.dealer.dealerCode,
                            BranchId: $scope.fields.dealer.branchCode,
                            Name: $scope.fields.dealer.name,
                            Address: $scope.fields.dealer.address,
                            State: $scope.fields.dealer.state,
                            Postcode: $scope.fields.dealer.postCode,
                            Suburb: $scope.fields.dealer.suburb,
                            Telephone: $scope.fields.dealer.telephone,
                            Email: $scope.fields.dealer.email
                        },
                        Address: $scope.fields.postCodeOrSuburb,
                        BuyingTimeLine: $scope.fields.buyingTimeline,
                        Agreement: agreement,
                        PhoneType: 'Not Specified',
                        FormName: $scope.fields.formName,
                        CampaignCode: $scope.fields.campaignCode
                    };
                };

                $scope.validateOtherVehicles = function (thisVehicle) {
                    switch (thisVehicle) {
                        case $scope.vehicleModelList[0]:
                            try {
                                $scope.wfm[$scope.vehicleModelList[1]].$validate();
                                $scope.wfm[$scope.vehicleModelList[2]].$validate();
                            } catch (e) {
                                // no errors if the fields don't exist
                            }

                            break;

                        case $scope.vehicleModelList[1]:
                            try {
                                $scope.wfm[$scope.vehicleModelList[0]].$validate();
                                $scope.wfm[$scope.vehicleModelList[2]].$validate();
                            } catch (e) {
                                // no errors if the fields don't exist
                            }

                            break;

                        case $scope.vehicleModelList[2]:
                            try {
                                $scope.wfm[$scope.vehicleModelList[0]].$validate();
                                $scope.wfm[$scope.vehicleModelList[1]].$validate();
                            } catch (e) {
                                // no errors if the fields don't exist
                            }

                            break;
                    }
                };

                $scope.vehicleInvalid = function (fieldId) {
                    // only validate while the user is filling the form
                    if (!$scope.wfm[fieldId].$touched && !$scope.wfm.$submitted) {
                        return false;
                    }

                    return !$scope.wfm[fieldId].$valid;
                };

                $scope.vehicleValid = function (fieldId) {
                    // only validate while the user is filling the form
                    if (!$scope.wfm[fieldId].$touched) {
                        return false;
                    }

                    return $scope.wfm[fieldId].$valid;
                };

                $scope.submit = function (goalId) {

                    if (!$scope.fields.dealerSelected) {
                        $scope.form.completed = true;
                        $scope.form.success = false;
                        return;
                    }

                    SitecoreAnalytics.triggerGoal(goalId);

                    $scope.form.submitting = true;

                    var url = $filter('formatArgs')(ToyotaForms.API.FormSubmission.BookATestDrive);
                    var data = $scope.getData();

                    API.post(url, data)
                        .then(function (req) {
                            $scope.form.submitting = false;

                            if (req.data.isSuccessful) {
                                $scope.form.completed = true;
                                $scope.form.success = true;
                            } else {
                                $scope.form.completed = true;
                                $scope.form.success = false;
                            }

                            if ($scope.form.completed && $scope.form.success) {
                                $scope.$broadcast('form-success');
                            } else {
                                $scope.$broadcast('form-failure');
                            }
                        }, function () {
                            $scope.form.completed = true;
                            $scope.form.success = false;
                            $scope.$broadcast('form-server-error');
                        });
                };
            }

            return {
                scope: true,
                restrict: 'A',
                controller: formsBookATestDriveController,
                controllerAs: 'fc',
                bindToController: true,
                link: function (scope, element, attrs) {
                    var destObj = {};

                    angular.forEach(element.find('ui-select'), function (ele) {
                        scope.vehicleModelList.push($(ele).attr('id'));
                        destObj[$(ele).attr('id')] = '';
                    });

                    //Extending select field models as these are dynamic(sitecore editable)
                    angular.extend(destObj, scope.fields);
                    scope.fields = destObj;
                }
            };
        }]);
})(window.angular, window.ToyotaForms);
